import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ModernBuildingIcon = createIcon({
  displayName: 'ModernBuildingIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M16,21V4a1,1,0,0,0-1-1H7.5a1,1,0,0,0-1,1V8.29779"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,21V12.9a.9.9,0,0,0-.9-.9H16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.00012,21,10.946,8.49557A1.5,1.5,0,0,0,8.7752,7.16026L4.10549,9.495a2,2,0,0,0-1.10561,1.78887V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="21.99999"
        y1="21"
        x2="1.99999"
        y2="21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="5.99999"
        y1="14"
        x2="7.99999"
        y2="14"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="5.99999"
        y1="17"
        x2="7.99999"
        y2="17"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ModernBuilding: FC<IconProps> = (props) => {
  return <CustomIcon as={ModernBuildingIcon} {...props} />
}

export default memo(ModernBuilding)
